export default __webpack_public_path__ + "c6d06da41ec4b66d90868ce6bf337cbd.ttf";